/* eslint-disable no-undef */
var hasDocument = typeof document === 'object' && document !== null;
var hasWindow = typeof window === 'object' && window !== null && window.self === window;
/* eslint-enable no-undef */

export var isBrowser = function isBrowser() {
  return hasDocument && hasWindow;
};